import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Grid,
  Box,
  Stack,
} from "@mui/material";
import "../TaskAssignment/TaskAssignment.css";
import { taskAssign } from "../../config/images";
import Pagination from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";
import { Padding } from "@mui/icons-material";

const ReportSubmission = () => {
  const tasks = [
    {
      srNo: "01",
      collector: "Jones Scott Jone",
      description: "Complete Farmer Information Survey",
      region: "North Central",
      state: "Adamawa",
      localGovt: "Aba North",
      farmers: 20,
      deadline: "30/01/2025",
      status: "Pending",
    },
    {
      srNo: "02",
      collector: "Scott Jones Lee",
      description: "Complete Farmer Information Survey",
      region: "North Central",
      state: "Adamawa",
      localGovt: "Aba North",
      farmers: 20,
      deadline: "25/01/2025",
      status: "Pending",
    },
    {
      srNo: "03",
      collector: "Jones Scott Jone",
      description: "Complete Farmer Information Survey",
      region: "North Central",
      state: "Adamawa",
      localGovt: "Aba North",
      farmers: 20,
      deadline: "30/01/2025",
      status: "Pending",
    },
    {
      srNo: "04",
      collector: "Scott Jones Lee",
      description: "Complete Farmer Information Survey",
      region: "North Central",
      state: "Akwa Ibom",
      localGovt: "Aba North",
      farmers: 20,
      deadline: "25/01/2025",
      status: "Complete",
    },
    {
      srNo: "05",
      collector: "Jones Scott Jone",
      description: "Complete Farmer Information Survey",
      region: "North Central",
      state: "Adamawa",
      localGovt: "Aba North",
      farmers: 20,
      deadline: "30/01/2025",
      status: "Pending",
    },
    {
      srNo: "06",
      collector: "Scott Jones Lee",
      description: "Complete Farmer Information Survey",
      region: "North Central",
      state: "Akwa Ibom",
      localGovt: "Aba North",
      farmers: 20,
      deadline: "25/01/2025",
      status: "Complete",
    },
    {
      srNo: "07",
      collector: "Jones Scott Jone",
      description: "Complete Farmer Information Survey",
      region: "North Central",
      state: "Adamawa",
      localGovt: "Aba North",
      farmers: 20,
      deadline: "30/01/2025",
      status: "Pending",
    },
    {
      srNo: "08",
      collector: "Scott Jones Lee",
      description: "Complete Farmer Information Survey",
      region: "North Central",
      state: "Adamawa",
      localGovt: "Aba North",
      farmers: 20,
      deadline: "25/01/2025",
      status: "Complete",
    },
    {
      srNo: "09",
      collector: "Jones Scott Jone",
      description: "Complete Farmer Information Survey",
      region: "North Central",
      state: "Adamawa",
      localGovt: "Aba North",
      farmers: 20,
      deadline: "30/01/2025",
      status: "Pending",
    },
    {
      srNo: "10",
      collector: "Scott Jones Lee",
      description: "Complete Farmer Information Survey",
      region: "North Central",
      state: "Akwa Ibom",
      localGovt: "Aba North",
      farmers: 20,
      deadline: "25/01/2025",
      status: "Complete",
    },
  ];

  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box className="task-assign-box">
            <Box className="d-flex justify-content-between align-items-center">
              <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
                <img
                  src={taskAssign.reportSub}
                  alt=""
                  style={{ height: "44px", width: "44px" }}
                />
                <Typography
                  variant="h6"
                  gutterBottom
              
                >
                  Tasks Report Submission
                </Typography>
              </Box>
            </Box>
            <Box style={{ width: "100%", overflowX: "auto" }}>
              <Table className="task-assign-table">
                <TableHead>
                  <TableRow>
                    <TableCell>Sr.No</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Data Collector</TableCell>
                    <TableCell>Task Title</TableCell>
                    <TableCell>Farmers Registered</TableCell>
                    <TableCell>Summary</TableCell>
                    <TableCell>Attachments</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tasks.map((task, index) => (
                    <TableRow key={index}>
                      <TableCell style={{textAlign: "center"}}>{task.srNo}</TableCell>
                      <TableCell>{task.deadline}</TableCell>
                      <TableCell>{task.collector}</TableCell>
                      <TableCell>{task.description}</TableCell>
                      <TableCell>{task.state}</TableCell>
                      <TableCell>{task.localGovt}</TableCell>
                      <TableCell>-</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
            <Box display="flex" justifyContent="end" alignItems="center">
              <Stack spacing={2} className="mb-2">
                <CustomPagination
                  count={4}
                  page={1}
                  //   onChange={handlePageChange}
                  // variant="outlined"
                  color="primary"
                />
              </Stack>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default ReportSubmission;
